import React from 'react'

import IconBxReceipt from "./Receipt";
import IconBxBookHeart from "./BookHeart";
import IconBxHomeHeart from "./HomeHeart";
import IconBxAtom from "./Atom";
import IconBxBroadcast from "./BoardCast";
import IconBxsLandmark from "./Landmark";
import IconBxShieldAlt from "./ShieldAlt";
import IconBxPlanet from "./Planet";
import IconBxNetworkChart from "./NetworkChart";
import IconBxlNetlify from "./Netlify";
import IconBxBuildingHouse from "./BuildingHouse";
import IconBxSuccess from "./Success";

export default class Icon extends React.Component {
	constructor(props) {
		super(props);
		const { size, color, icon, style: styleArg, ...svgProps } = props
		this.state = { size, color, icon, styleArg, svgProps }
	}

	render() {
		let svgExtraProps = {}

		if (this.state.size !== undefined) {
			svgExtraProps.width = `${this.state.size}px`
			svgExtraProps.height = `${this.state.size}px`
		} else {
			// default
			svgExtraProps.width = '24px'
			svgExtraProps.height = '24px'
		}

		if (this.state.color !== undefined) {
			svgExtraProps.style = { color: this.state.color, ...this.state.styleArg }
		}

		return this.state.icon({...this.state.svgProps, ...svgExtraProps})
	}
}

export {
	IconBxReceipt,
	IconBxBookHeart,
	IconBxHomeHeart,
	IconBxAtom,
	IconBxBroadcast,
	IconBxsLandmark,
	IconBxShieldAlt,
	IconBxPlanet,
	IconBxNetworkChart,
	IconBxlNetlify,
	IconBxBuildingHouse,
	IconBxSuccess
}